import { deliveryKey, entriesKey, summaryKey } from '@/features/delivery/config/deliveryQueryKeys';
import type { QueryClient } from '@tanstack/react-query';

/** Delivery and customer Output reads share the same Entry build state. */
export function invalidateDeliveryBuildReads(qc: QueryClient, deliveryId: string) {
  return Promise.all([
    qc.invalidateQueries({ queryKey: summaryKey(deliveryId) }),
    qc.invalidateQueries({ queryKey: entriesKey(deliveryId) }),
  ]);
}

export function invalidateDeliveryAggregate(qc: QueryClient, deliveryId: string) {
  return Promise.all([
    qc.invalidateQueries({ queryKey: deliveryKey(deliveryId) }),
    invalidateDeliveryBuildReads(qc, deliveryId),
  ]);
}
